<script lang="ts">
  import { onDestroy, onMount } from 'svelte';
  import { _ } from 'svelte-i18n';
  import { getAppConfig } from '../../../common/config/app-config.js';
  import { getDateStringInCurrentLang, getStr } from '../../../common/util.js';
  import Text from '../../common/components/Text.svelte';
  import { error, options, success } from '../services/pdp-data-services.js';
  import { nearestPickupStore, pdpCollectionPointData, pdpSellerInfoData } from './../store/pdp_store.js';
  import OnDemandPdpBlock from './OnDemandPDPBlock.svelte';
  import PDPCollectionPoints from './PDPCollectionPoints.svelte';
  import ProductDeliveryDescription from './ProductDeliveryDescription.svelte';
  import ProductDeliveryHeader from './ProductDeliveryHeader.svelte';

  export let isQacPopup: boolean;
  export let cfsPosPickUpInStoreData;
  export let homeDeliveryData;
  export let code;
  export let isHomeDeliveryEnabled;
  export let stock;
  export let cfsBackOrderEligible;
  export let cfsBackOrderLaunchDate;
  export let collectionPointData;

  // export let isTransactional;

  export let deliveryLeadMessage = null;
  export let deliveryLeadTimeNow = null;
  export let deliveryLeadTimeBeforeBy = null;
  export let displayFreeDelivery;
  export const deliveryPayment = null;
  export let expressDeliveryMode = null;
  export let isCollectFromStoreEnabled: boolean;
  export let productStatus;
  export let shippingClassification;
  export let standardDeliveryCost;
  export let deliveryLeadTimeBefore = null;
  export let onDemandDeliveryMode = null;
  export let marketPlaceProduct = false;
  export let marketPlaceOfferData = null;

  const { currentCity, userSelectedCity, lang, isTransactional } = getAppConfig();
  //   let cfsPreOrderDate = getDateStringInCurrentLang(convertTimeStampToDate(cfsBackOrderLaunchDate), lang);
  let _geoWatch;
  const currentUserCity = currentCity || userSelectedCity;
  const currentCityName =
    lang === 'en' ? currentUserCity?.nameEn || userSelectedCity : currentUserCity?.nameAr || userSelectedCity;

  $: defaultPos = cfsPosPickUpInStoreData?.defaultPos;
  $: cnbh = defaultPos?.collectNbHours;
  $: icih = defaultPos?.isCollectInHours;
  $: storeCollectHours = defaultPos?.storeCollectHours;
  // Determines if the product is eligible for backorder with a specific launch date
  // This will be true if the product is backorder eligible and has a launch date
  $: cfsBackOrderWithDate = cfsBackOrderEligible && cfsBackOrderLaunchDate !== null;

  // Determines whether to show the collect from store option for pre-order products
  // This will be true if the product is not a pre-order or if it is eligible for backorder with a date
  $: showCfsForPreOrder = productStatus !== 'PRE_ORDER' || cfsBackOrderWithDate;

  $: storeInStock = stock?.stockLevelStatus?.code != 'outOfStock';
  $: cfsInStock =
    cfsPosPickUpInStoreData?.defaultPos?.stockData?.stockLevelStatus?.code === 'inStock' ||
    cfsPosPickUpInStoreData?.defaultPos?.stockData?.stockLevelStatus?.code === 'lowStock';
  $: cfsStockStatus = cfsPosPickUpInStoreData?.defaultPos?.stockData?.stockLevelStatus?.code;
  $: cfsStockCount = cfsPosPickUpInStoreData?.defaultPos?.stockData?.stockLevel;
  $: storePickupLocation =
    cfsPosPickUpInStoreData != null
      ? lang != 'en'
        ? cfsPosPickUpInStoreData?.defaultPos.nameAr
        : cfsPosPickUpInStoreData?.defaultPos.nameEn
      : '';
  const storePickupTitle = $_(getStr('pdp.storePickupTitle'));
  const notAvailableTitle = $_(getStr('extra.pdp.cfs.preorder.not.available'));

  $: deliveryInStock =
    homeDeliveryData?.currentCityStockData?.stockLevelStatus?.code === 'inStock' ||
    homeDeliveryData?.currentCityStockData?.stockLevelStatus?.code === 'lowStock';
  $: deliveryStockStatus = homeDeliveryData?.currentCityStockData?.stockLevelStatus?.code;
  $: deliveryStockCount = homeDeliveryData?.currentCityStockData?.stockLevel;
  $: MpStockCount = stock?.stockLevel;
  $: MpInStock = stock?.stockLevelStatus?.code === 'inStock' || stock?.stockLevelStatus?.code === 'lowStock';
  $: MpStockStatus = stock?.stockLevelStatus?.code;
  $: isMarketplaceProduct = isQacPopup ? marketPlaceProduct : $pdpSellerInfoData?.marketPlaceProduct;
  $: showMPdeliveryRange =
    isQacPopup && marketPlaceOfferData !== null
      ? marketPlaceOfferData?.shippedBySeller
      : $pdpSellerInfoData?.marketPlaceOfferData?.shippedBySeller;
  $: cpDeliveryData = isQacPopup ? collectionPointData : $pdpCollectionPointData;

  const deliveryTitle = $_(getStr('pdp.deliveryTitle'));

  const diffrentStorelable = getStr('extra.pdp.oos.diffrentStorelable');
  const currentlydeliverynotavailable = getStr('extra.pdp.oos.currentlydeliverynotavailable');
  const neareststoreforproductlable = getStr('extra.pdp.oos.neareststoreforproductlable');

  onMount(async () => {
    _geoWatch = navigator.geolocation.getCurrentPosition(success, error, options);
  });

  onDestroy(() => {
    if (_geoWatch) {
      navigator.geolocation.clearWatch(_geoWatch);
    }
  });
</script>

<section class="product_delivery">
  {#if !isMarketplaceProduct}
    {#if (storeInStock === true || $nearestPickupStore !== null) && isCollectFromStoreEnabled && (isTransactional == 'true' || isTransactional == true) && cfsPosPickUpInStoreData}
      <div class="mini-card store-pick-up">
        <ProductDeliveryHeader
          inStock={cfsInStock}
          stockStatus={cfsBackOrderEligible ? notAvailableTitle : cfsStockStatus}
          stockCount={cfsStockCount}
          title={storePickupTitle}
          location={storePickupLocation}
          isStorePickup={true}
          {code}
          {isCollectFromStoreEnabled}
          {cfsPosPickUpInStoreData}
          {cfsBackOrderEligible}
        />
        {#if cfsInStock}
          <div class="description">
            {#if cfsBackOrderWithDate}
              <ProductDeliveryDescription
                icon="icon-shop"
                collectInHours={getDateStringInCurrentLang(cfsBackOrderLaunchDate, lang)}
                isCfsPreOrder={showCfsForPreOrder}
              />
            {:else if cnbh > 0}
              {#if icih}
                <ProductDeliveryDescription icon="icon-shop" collectInHours={storeCollectHours} />
              {:else}
                <ProductDeliveryDescription icon="icon-shop" collectInHours={storeCollectHours} icihtime={cnbh} />
              {/if}
            {:else}
              <ProductDeliveryDescription icon="icon-shop" description={getStr('product.pickupinstore.closed')} />
            {/if}
          </div>
        {:else}
          <div class="outofstock">
            <span class="outofstock-heading">{diffrentStorelable}</span>
            {#if isCollectFromStoreEnabled && $nearestPickupStore !== null && (productStatus !== 'PRE_ORDER' || cfsBackOrderEligible)}
              <span class="outofstock-subheading"
                >{neareststoreforproductlable}
                <span
                  data-productcode={code}
                  data-storename={$nearestPickupStore.name}
                  class="nearest-store select-store-button__new-modal"
                >
                  {$nearestPickupStore.displayName}
                </span>
              </span>
            {/if}
          </div>
        {/if}
      </div>
    {/if}
    {#if cpDeliveryData && storeInStock}
      <div class="mini-card collection-points">
        <PDPCollectionPoints
          data={cpDeliveryData}
          location={currentCityName}
          {code}
          {isCollectFromStoreEnabled}
          {cfsPosPickUpInStoreData}
        />
      </div>
    {/if}
    {#if (storeInStock || deliveryInStock) && isHomeDeliveryEnabled && (isTransactional == 'true' || isTransactional == true)}
      <div class="mini-card delivery">
        <ProductDeliveryHeader
          inStock={deliveryInStock}
          stockStatus={deliveryStockStatus}
          stockCount={deliveryStockCount}
          title={deliveryTitle}
          location={currentCityName}
          {code}
          {isCollectFromStoreEnabled}
          {cfsPosPickUpInStoreData}
        />
        {#if homeDeliveryData.currentCityStockData?.stockLevelStatus?.code != 'outOfStock'}
          <div class="description">
            <section class="delivery-info-block std-delivery-block">
              <ProductDeliveryDescription
                icon="icon-standard_delivery_plain"
                deliveryType={getStr('account.addressbook.update.deliverymode')}
                deliveryCost={displayFreeDelivery === true ? 0 : standardDeliveryCost?.value}
              />
              {#if shippingClassification === 'LARGE'}
                <div class="info">
                  <Text key="largeItemDeliveryLeadMessage" />
                </div>
              {/if}
              {#if shippingClassification === 'SMALL'}
                {#if deliveryLeadMessage}
                  <div class="c_predelivery-message" id="c_predelivery-message">
                    {@html deliveryLeadMessage}
                  </div>
                {:else}
                  {#if deliveryLeadTimeNow !== null}
                    <div class="info">
                      <Text key="product.dlt.order.now" />
                      <span><strong>{getDateStringInCurrentLang(deliveryLeadTimeNow, lang)}</strong></span>
                    </div>
                  {/if}
                  {#if deliveryLeadTimeBefore !== null}
                    <div class="info">
                      <Text key="product.dlt.order.before" args={[deliveryLeadTimeBefore]} />
                      <span><strong>{getDateStringInCurrentLang(deliveryLeadTimeBeforeBy, lang)}</strong></span>
                    </div>
                  {/if}
                {/if}
              {/if}
            </section>
          </div>
          <div class="shopping-fees-and-policies-link-wrapper">
            <a target="_blank" href="/delivery" rel="nofollow noopener noreferrer"
              ><Text key="extra.pdp.view.all.our.shipping.fees.and.policies" /></a
            >
          </div>
        {:else}
          <div class="outofstock">
            <span class="outofstock-heading">{currentlydeliverynotavailable}</span>
          </div>
        {/if}
      </div>
    {/if}

    {#if expressDeliveryMode || onDemandDeliveryMode}
      <div class="mini-card on-demand">
        <OnDemandPdpBlock {expressDeliveryMode} {onDemandDeliveryMode} />
      </div>
    {/if}
  {:else if MpInStock && (isTransactional == 'true' || isTransactional == true)}
    <div class="mini-card delivery marketplace_delivery">
      <ProductDeliveryHeader
        inStock={MpInStock}
        stockStatus={MpStockStatus}
        stockCount={MpStockCount}
        title={deliveryTitle}
        location={currentCityName}
        {code}
        {isCollectFromStoreEnabled}
        {cfsPosPickUpInStoreData}
      />
      {#if stock?.stockLevelStatus?.code != 'outOfStock'}
        <div class="description">
          <section class="delivery-info-block std-delivery-block">
            <ProductDeliveryDescription
              icon="icon-standard_delivery_plain"
              deliveryType={getStr('account.addressbook.update.deliverymode')}
              {showMPdeliveryRange}
              {isMarketplaceProduct}
            />
            {#if !showMPdeliveryRange}
              {#if deliveryLeadMessage}
                <div class="c_predelivery-message" id="c_predelivery-message">
                  {@html deliveryLeadMessage}
                </div>
              {:else}
                {#if deliveryLeadTimeNow !== null}
                  <div class="info">
                    <Text key="extra.marketplace.product.deliveryleadtimenow.label" />
                    <span><strong>{getDateStringInCurrentLang(deliveryLeadTimeNow, lang)}</strong></span>
                  </div>
                {/if}
                {#if deliveryLeadTimeBefore !== null}
                  <div class="info">
                    <Text
                      key="extra.marketplace.product.deliveryleadtimebefore.label"
                      args={[deliveryLeadTimeBefore]}
                    />
                    <span><strong>{getDateStringInCurrentLang(deliveryLeadTimeBeforeBy, lang)}</strong></span>
                  </div>
                {/if}
              {/if}
            {/if}
          </section>
        </div>
      {:else}
        <div class="outofstock">
          <span class="outofstock-heading">{currentlydeliverynotavailable}</span>
        </div>
      {/if}
    </div>
  {/if}
</section>

<style lang="scss">
  @import '../../common/styles/colors.new.scss';

  .product_delivery {
    display: flex;
    flex-direction: column;
    gap: 8px;

    .mini-card {
      padding: 8px;
      border-radius: 8px;
      background-color: $primary-white;
    }
  }
  .description {
    display: flex;
    flex-direction: column;
    gap: 12px;
    margin-top: 12px;

    .delivery-info-block {
      .info {
        display: flex;
        font-weight: 400;
        font-size: 14px;
        line-height: 16px;
        gap: 4px;
        margin-top: 8px;
      }
    }

    @include desktop-min-width {
      margin-top: 14px;
    }
  }
  .outofstock {
    display: flex;
    flex-direction: column;
    gap: 2px;
    margin-top: 12px;
    margin-bottom: 24px;
    &-heading {
      font-weight: 400;
      font-size: 14px;
      line-height: 16px;
      color: $functional-orange;
    }
    &-subheading {
      font-weight: 400;
      font-size: 12px;
      line-height: 14px;

      .nearest-store {
        font-weight: 500;
        color: $icon-only-icon-blue;
        cursor: pointer;
      }
    }

    @include desktop-min-width {
      margin-top: 14px;
      gap: 4px;

      &-heading {
        font-weight: 500;
        font-size: 16px;
        line-height: 18px;
      }
      &-subheading {
        font-weight: 400;
        font-size: 14px;
        line-height: 16px;

        .nearest-store {
          font-weight: 500;
        }
      }
    }
  }

  .total-outofstock-subheading {
    font-weight: 700;
    font-size: 24px;
    line-height: 28px;
    margin-top: 4px;

    @include desktop-min-width {
      font-size: 36px;
      line-height: 40px;
      margin-top: 8px;
    }
  }
  .shopping-fees-and-policies-link-wrapper {
    display: flex;
    padding-top: 1rem;
    padding-bottom: 0;
    a {
      font-size: 1.4rem;
      font-weight: 500;
    }
  }
  :global {
    #c_predelivery-message {
      color: $neutral-dark-01;
      p {
        color: $neutral-dark-01;
      }
    }
  }
</style>
